import appConfig from "@/config/appConfig";
import { Button, Spin } from "antd";
import axios from "axios";
import { useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import { FaPlus } from "react-icons/fa";
import Swal from "sweetalert2";
import { FormulaForm } from "./FormulaForm";
import FormulasTable from "./FormulasTable";
import { flare } from "@flareapp/js";

const ManageFormulas = () => {
  const [parameters, setParameters] = useState([]);
  const [formulas, setFormulas] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [loading, setLoading] = useState(true);
  const [selectedFormula, setSelectedFormula] = useState();
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(10);
  const [total, setTotal] = useState(0);

  const getParameters = async () => {
    try {
      const response = await axios.get(`/system-parameter`, { withCredentials: true });
      if (response) {
        setParameters(response.data.results);
      }
    } catch (error) {
      flare.report(error);
      // eslint-disable-next-line no-console
      console.log(error);
    }
  };

  const getFormulas = async () => {
    setLoading(true);
    try {
      const response = await axios.get(`/formula`, {
        withCredentials: true,
        params: {
          type: "system",
          page,
          limit,
        },
      });
      if (response) {
        setFormulas(
          Array.isArray(response.data?.result)
            ? response.data?.result?.map((item, idx) => {
                item.idx = idx + 1;
                return item;
              })
            : [],
        );
        setTotal(response.data?.meta?.count);
      }
    } catch (error) {
      flare.report(error);
      // eslint-disable-next-line no-console
      console.log(error);
    }

    setLoading(false);
  };

  const onFinish = () => {
    handleCancelModal();
    getFormulas();
  };

  useEffect(() => {
    getParameters();
  }, []);

  useEffect(() => {
    getFormulas();
  }, [page, limit]);

  const deleteFormula = async (formulaId) => {
    Swal.fire({
      title: "Are you sure?",
      text: "You want to delete formula?",
      //icon: "warning",
      dangerMode: true,
      showCancelButton: true,
      confirmButtonText: "Confirm",
    }).then((result) => {
      if (result.isConfirmed) {
        axios.delete(`/formula/` + formulaId, { withCredentials: true }).then(() => {
          getFormulas();
          Swal.fire({
            title: "Done!",
            text: "Formula Deleted Successfully",
            icon: "success",
            timer: 2000,
            button: false,
          });
        });
      }
    });
  };

  const handleEdit = (row) => {
    setSelectedFormula(row);
    setShowModal(true);
  };

  const handleCancelModal = () => {
    setShowModal(false);
    setSelectedFormula();
  };

  useEffect(() => {
    document.title = `${appConfig.name} - Manage Formulas`;
  }, []);

  return (
    <div className="card p-3 m-md-3">
      <div className="d-flex flex-column flex-md-row g-3 align-items-md-center mb-3 justify-content-between">
        <div>
          <label className="az-content-label">Settings</label>
          <span className="d-block py-2">Manage Formulas</span>
        </div>
        <div className="ms-md-auto p-0">
          <Button icon={<FaPlus />} type="primary" onClick={() => setShowModal(true)}>
            Create Formula
          </Button>
        </div>
      </div>
      <hr className="mt-0" />

      <Modal
        show={showModal}
        style={{ width: "100%" }}
        centered
        className="col-md-12"
        size="xl"
        onHide={handleCancelModal}
      >
        <Modal.Body>
          <FormulaForm
            parameters={parameters}
            formulas={formulas}
            mode={selectedFormula ? "edit" : "create"}
            data={selectedFormula}
            onFinish={onFinish}
            onCancel={handleCancelModal}
          />
        </Modal.Body>
      </Modal>
      <Spin spinning={loading}>
        <div className="row">
          <FormulasTable
            showPeriodAndFallback={false}
            formulas={formulas}
            getFormulas={getFormulas}
            onDeleteRow={(row) => deleteFormula(row._id)}
            onEditRow={handleEdit}
            {...{ page, setPage, limit, setLimit, total }}
          />
        </div>
      </Spin>
    </div>
  );
};

export default ManageFormulas;
